import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Import pages
import HomePage from './pages/Home';
import BookingPage from './pages/Booking';
import PaymentPage from './pages/Payment';
import SuccessPage from './pages/Success';
import HouseRulesPage from './pages/HouseRules';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import AdminPage from './pages/Admin';
import NotFoundPage from './pages/NotFound';

const App: React.FC = () => {
  return (
    <>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/house-rules" element={<HouseRulesPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;
